import { Accordion, Form } from "react-bootstrap";
import SimpleBar from "simplebar-react";

export const SurfacesToolbox = ({surfacesData, selectedSurfacesData, isSelectAllSurfacesChecked, handleSelectAllSurfaces, handleSurfacesSelectionUpdate}) => {
    return <Accordion.Item eventKey='3'>
        <Accordion.Header>
            <i className="fi-play me-2 rotate-negative-90"></i>Surfaces
        </Accordion.Header>
        <Accordion.Body>
            {surfacesData.length > 1 && <Form.Check id="select-all-surfaces" value={isSelectAllSurfacesChecked} checked={isSelectAllSurfacesChecked} onChange={e => handleSelectAllSurfaces(e)} label={<><span className='fs-sm fw-bold'>All</span></>} />}
            <SimpleBar autoHide={false} className='simplebar-no-autohide toolbox-max-height'>                        
                {surfacesData.map(item => (
                    <Form.Check 
                        id={item.id}
                        checked={selectedSurfacesData.includes(item.id)}
                        key={item.id} 
                        value={item.id} 
                        onChange={e => handleSurfacesSelectionUpdate(e, item)} 
                        label={<><span className='fs-sm'>{item.name}</span></>} 
                    />
                ))} 
            </SimpleBar>
        </Accordion.Body>
    </Accordion.Item>
}